import { appConstants } from "../helpers/constants";

export const varsActions = {
  setStartDate,
  setEndDate,
};

function setStartDate(obj) {
  return (dispatch) => {
    dispatch({
      type: appConstants.SET_START_DATE,
      startDate: obj.startDate,
    });
  };
}

function setEndDate(obj) {
  return (dispatch) => {
    dispatch({
      type: appConstants.SET_END_DATE,
      endDate: obj.endDate,
    });
  };
}
